var map = {
	"./Away.svg": 25128,
	"./Away_old.svg": 47010,
	"./Busy.svg": 6645,
	"./Offline.svg": 97415,
	"./OnThePhone.svg": 57402,
	"./OnThePhone_F2F.svg": 73713,
	"./OnThePhone_TEL.svg": 82948,
	"./Online.svg": 65275,
	"./chat2Tel.svg": 79969,
	"./exclamation.svg": 18873,
	"./heart-hover.svg": 58483,
	"./heart-white-current.svg": 38574,
	"./heart-white.svg": 32542,
	"./heart.svg": 18066,
	"./maximo_service_request.svg": 57043,
	"./maximo_solution.svg": 50769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19832;